import type { TableSnapshot, ViewSpec } from '@components/ui/DataSheet';

import { ReparoApi } from './index';

export interface GenerateTableViewResult extends ViewSpec {
    /** Short human summary of what the agent did. */
    summary: string;
}

/**
 * Translate a natural-language request into a table ViewSpec, given the resolved table snapshot.
 * Stateless and non-mutating — the returned spec is applied client-side by the DataSheet engine.
 */
export const generateTableView = async (payload: {
    prompt: string;
    snapshot: TableSnapshot;
    currentSpec?: ViewSpec;
}): Promise<GenerateTableViewResult> =>
    ReparoApi({
        method: 'POST',
        url: '/table-view/generate',
        body: JSON.stringify({
            prompt: payload.prompt,
            columns: payload.snapshot.columns,
            rows: payload.snapshot.rows,
            currentSpec: payload.currentSpec,
        }),
    });
